/* eslint-disable react-hooks/exhaustive-deps */
import { Container } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import BreadcrumbComponent from '../../components/BreadcrumbComponent/BreadcrumbComponent';
import MonthlyClaimList from '../../components/MarketDevelopment/MonthlyClaim/Dashboard/MonthlyClaimList';
import MonthlyDistributionList from '../../components/MarketDevelopment/MonthlyDistributionChannel/Dashboard/MonthlyDistributionList';
import MonthlySaleList from '../../components/MarketDevelopment/MonthlySale/Dashboard/MonthlySaleList';
import PrintLayout from '../../components/Print/PrintLayout';
import c from '../../constant';
import { getReportTitle } from './Utils';
import QuarterlyClaimList from '../../components/MarketDevelopment/QuarterlyClaim/Dashboard/QuarterlyClaimList';
import AnnuallySaleList from '../../components/MarketDevelopment/AnnuallySale/Dashboard/AnnuallySaleList';
import QuarterlySaleList from '../../components/MarketDevelopment/QuarterlySale/Dashboard/QuarterlySaleList';
import AnnuallyClaimList from '../../components/MarketDevelopment/AnnuallyClaim/Dashboard/AnnuallyClaimList';
import AnnuallyDistributionList from '../../components/MarketDevelopment/AnnuallyDistributionChannel/Dashboard/AnnuallyDistributionList';

function Dashboard() {
	const location = useLocation();
	const urlParams = new URLSearchParams(location.search);
	const period = urlParams.get('period') ?? null;
	const reportId = urlParams.get('reportId') ?? null;

	useEffect(() => window.scrollTo(0, 0), []);

	return (
		<PrintLayout>
			<>
				<Container maxW="container.xl" mt="16px" mb="16px">
					<BreadcrumbComponent
						list={[
							{
								name: 'Insurance Institute Report',
								path: '/company-submission-report',
							},
							{
								name: period,
								path: '/company-submission-report?period=' + period,
							},
							{
								name: getReportTitle(reportId),
								path: '#',
							},
						]}
					/>
					{reportId === c.monthly_sale_report && <MonthlySaleList />}
					{reportId === c.monthly_claim_report && <MonthlyClaimList />}
					{reportId === c.monthly_distribution_channel_report && <MonthlyDistributionList />}
					{reportId === c.quarterly_claim_report && <QuarterlyClaimList />}
					{reportId === c.annually_sale_report && <AnnuallySaleList />}
					{reportId === c.quarterly_sale_report && <QuarterlySaleList />}
					{reportId === c.annually_claim_report && <AnnuallyClaimList />}
					{reportId === c.annually_distribution_channel_report && <AnnuallyDistributionList />}
				</Container>
			</>
		</PrintLayout>
	);
}

export default Dashboard;
